import React from "react"
import axios from 'axios'
import { MDCLinearProgress } from '@material/linear-progress';
import { MDCRipple } from '@material/ripple';
import { MDCTextField } from '@material/textfield';
import $ from "jquery";
import Chart from 'chart.js';

function getBalance() {
  axios.get("https://nakrutkatop.com:443/api/partners", { withCredentials: true })
    .then(res => {
      setTimeout(() => {
        try {
          document.getElementById("main-content").style.opacity = 1
          document.getElementById("main-content").style.visibility = "visible"
        }
        catch { }
      }, 50)
      document.querySelector("#ref_count").innerHTML = res.data.ref_count
      document.querySelector("#ref_profit").innerHTML = res.data.ref_profit + "$"
      document.querySelector("#ref_share").innerHTML = res.data.ref_share + "%"

      document.querySelector("#refLink").value = res.data.link

    }
    )
}

class PartnersPage extends React.Component {

  componentDidMount() { 

    document.querySelector("#refLink").onkeypress = () => false
    new MDCTextField(document.querySelector('#linkField'));
    new MDCRipple(document.querySelector('#copyBtn'));
    document.querySelector("#copyBtn").onclick = () => {
      document.querySelector("#refLink").select()
      document.querySelector("#refLink").setSelectionRange(0, 99999)
      document.execCommand("copy")
    }
  }

  render(props) {
    getBalance()
    return <div className="mdc-drawer-app-content mdc-top-app-bar--fixed-adjust icontent" >
      <main className="main-content" id="main-content" style={{ opacity: "0", visibility: "hidden", transition: ".3s opacity, .3s visibility" }}>

        <h2 className="pageHeader">Партнёры</h2>

        <div className="irow" style={{ display: "flex", flexWrap: "wrap" }}>

          <div className="ibox" style={{ margin: "0px 8px 16px", flex: "0 0 535px", width: "535px", maxWidth: "100%" }}>
            <h3 className="ibox_title">Партнёрская ссылка</h3>
            <div className="ibox_content" style={{ padding: "0 16px 16px", display: "block"}}>
              <div style={{display: "flex"}}>
              <label class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-leading-icon mdc-text-field--label-floating" id="linkField" style={{ width: "100%", display: "inline-flex", marginBottom: "0px" }}>
                <i className="fas fa-link mdc-text-field__icon mdc-text-field__icon--leading" style={{ marginLeft: "15px", marginRight: "10px", color: "rgba(255,255,255,.77)" }}></i>
                <input type="text" class="mdc-text-field__input" aria-labelledby="modalLabelLink" id="refLink" />
                <span class="mdc-notched-outline">
                  <span class="mdc-notched-outline__leading"></span>
                  <span class="mdc-notched-outline__notch" id="outline3">
                    <span class="mdc-floating-label mdc-floating-label--float-above" id="linkLabel">Ваша реферальная ссылка</span>
                  </span>
                  <span class="mdc-notched-outline__trailing"></span>
                </span> 
              </label>
              <button class="mdc-button mdc-button--raised mdc-ripple-upgraded" id="copyBtn" style={{display: "inline-flex", height: "56px", width: "56px", borderRadius: "6px", marginLeft: "16px" }}>
                <div class="mdc-button__ripple" style={{borderRadius: "6px"}}></div>
                <i className="fas fa-copy"></i>
              
              </button>
            </div></div>
          </div>
        </div>

        <div className="irow" style={{ display: "flex", flexWrap: "wrap" }}>
          <div className="ibox" style={{ margin: "0px 8px 16px", maxWidth: "167px" }}>
            <h3 className="ibox_title">Партнёры</h3>
            <div className="ibox_content" style={{ alignItems: "center" }}>
              <div className="ibalance" id="ref_count" style={{ marginTop: "16px" }}></div>
            </div>
          </div>

          <div className="ibox" style={{ margin: "0px 8px 16px", maxWidth: "167px" }}>
            <h3 className="ibox_title">Заработано</h3>
            <div className="ibox_content" style={{ alignItems: "center" }}>
              <div className="ibalance" id="ref_profit" style={{ marginTop: "16px" }}></div>
            </div>
          </div>

          <div className="ibox" style={{ margin: "0px 8px 16px", maxWidth: "167px", minHeight: "136px" }}>
            <h3 className="ibox_title">Начисления</h3>
            <div className="ibox_content" style={{ alignItems: "center" }}>
              <div className="ibalance" id="ref_share" style={{ marginBottom: "6px" }}></div>
              <p style={{ marginBottom: "0px" }}>от пополнений</p>
            </div>
          </div>

        </div>




      </main>
    </div>
  }
}

export default PartnersPage

/*


    var ctx = document.getElementById('myChart');
    var ctx2 = document.getElementById('myChart2');
    var myChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: ["Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье"],
        datasets: [{
          data: [10, 15, 7, 16, 0, 2, 8, 27, 25, 12],
          label: "Новых партнёров",
          borderColor: "#6200ee",
          fill: true
        },
        ]
      },
      options: {
        title: {
          display: false,
          text: 'World population per region (in millions)'
        }
      }
    });
    var myChart2 = new Chart(ctx2, {
      type: 'line',
      data: {
        labels: ["Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье"],
        datasets: [{
          data: [12, 150, 70, 20, 0, 135, 80, 270, 15, 120],
          label: "Партнёрские начисления",
          borderColor: "#6200ee",
          fill: true
        },
        ]
      },
      options: {
        title: {
          display: false,
          text: 'World population per region (in millions)'
        }
      }
    });

 <div className="irow" style={{display: "flex", flexWrap: "wrap"}}>
          <div className="ibox" style={{ width: "707px", flex: "0 0 707px", maxWidth: "100%",  }}>
            <h3 className="ibox_title">Статистика</h3>
            <div className="ibox_content" style={{overflowX: "auto", maxWidth: "100%",}}>
              <canvas id="myChart" width="400" height="100" style={{minWidth: "400px", minHeight: "100px"}}></canvas>
              <canvas id="myChart2" width="400" height="100" style={{minWidth: "400px", minHeight: "100px"}}></canvas>
            </div>
          </div>

        </div>

*/